import React from "react";
import { useGame } from "context/gameContext";
import { useRound } from "context/roundContext";
import { useLeague } from "context/leagueContext";
import { useEventPickData } from "hooks/useEventPickData";
import EventInfo from "components/eventInfo";
import LmsPicks from "components/lmsPicks";
import TeamForm from "components/teamForm";
import { useEventPick } from "context/eventPickContext";
import { PredictButton } from "components/predictButton";

const EventCardLms = ({ eventInfo }) => {
  const {
    state: { settings },
  } = useGame();
  const {
    state: { tournamentInfo, leagueTeams, nextRoundId, leagueInfo },
  } = useLeague();

  const {
    state: { currentRound },
  } = useRound();

  const {
    state: {
      eventData: event,
      eventPick,
      isLoading: eventPickLoading,
      outcomes,
    },
  } = useEventPick();

  useEventPickData(eventInfo);

  let homeForm = leagueTeams.find((x) => x.id === event?.teams?.home?.id)
    ?.statistics?.formList;
  let awayForm = leagueTeams.find((x) => x.id === event?.teams?.away?.id)
    ?.statistics?.formList;
  let roundStarted =
    currentRound?.deadline?.seconds * 1000 < new Date() ||
    currentRound?.settled;

  const eventData = {
    ...event,
    leagueId: leagueInfo?.leagueRef,
    seasonId: leagueInfo?.seasonRef,
    roundId: currentRound?.id,
    eventId: event?.id,
  };

  const showLogos =
    !settings?.copyrightMode ||
    tournamentInfo?.clubLogos ||
    leagueInfo?.clubLogos;

  return roundStarted ? (
    <div className="flex flex-row " key={event?.id}>
      <EventInfo
        event={eventData}
        showLogos={showLogos}
        gameRule={leagueInfo?.gameRule}
        prediction={true}
      />
      <LmsPicks />
    </div>
  ) : (
    <div className="flex flex-col " key={event?.id}>
      <div className="flex w-full ">
        {outcomes &&
          Object.keys(outcomes).map((key) => {
            if (key == 2) {
              return (
                <div className="w-10 md:w-14 shrink-0 flex bg-black text-white justify-center items-center text-sm md:text-lg">
                  <div className="flex">VS</div>
                </div>
              );
            } else return <PredictButton outcome={key} home={key == 1} />;
          })}
      </div>

      {event?.postponed ? (
        <div className="flex w-full text-sm text-black/80 bg-white/40 rounded-b-xl px-2 py-1 justify-center">
          Event postponed
        </div>
      ) : (
        nextRoundId == currentRound?.id && (
          <div className="flex w-full text-sm text-black/80 ">
            <div className="flex w-full justify-between bg-white/40 py-1 rounded-bl-xl px-2">
              <TeamForm form={homeForm} />
              <div className="flex overflow-hidden text-xs md:text-sm justify-center items-center">
                {event?.homeOdds ? event?.homeOdds : "-"}
              </div>
            </div>
            <div className="w-10 md:w-14 shrink-0 flex items-center justify-center  text-xs md:text-sm bg-white/40 py-1">
              {event?.drawOdds ? event?.drawOdds : "-"}
            </div>
            <div className="flex w-full justify-between bg-white/40 py-1 rounded-br-xl px-2">
              <div className="flex overflow-hidden text-xs md:text-sm justify-center items-center">
                {event?.awayOdds ? event?.awayOdds : "-"}
              </div>
              <TeamForm form={awayForm} />
            </div>
          </div>
        )
      )}
    </div>
  );
};

export default EventCardLms;
